import React from "react";
import { AccountingGroup, PrimaryLedger, PrimaryLedgerNames } from "../../../interfaces/Accounts";
import AccountingList from "../AccountList";

interface AssetsProps {
  data: PrimaryLedger;
  setSelectedParent: (data: Partial<AccountingGroup>) => void;
}

export default function Assets({ data, setSelectedParent }: AssetsProps): JSX.Element {
  return (
    <AccountingList
      header={PrimaryLedgerNames.ASSETS}
      setSelectedParent={setSelectedParent}
      data={data}
    />
  );
}
